export const LANG_ID_MAP: any = {
    es: 1,
    en: 2,
    fr: 3,
    it: 4,
    ru: 5
}

export const LANG_CODE_MAP: any = {
    1: "es",
    2: "en",
    3: "fr",
    4: "it",
    5: "ru"
}

export const LANG_NAME_MAP: any = {
    1: "Español",
    2: "English",
    3: "Français",
    4: "Italiano",
    5: "Русский"
}

// I recommend using this tool to generate the colors:
// https://materialpalettes.com/
export const CUSTOMER_THEMES: any = {
    // PokerStars
    2: {
        primaryColor: {
            "50": "#ffe8e7",
            "100": "#ffc9c9",
            "200": "#ff9999",
            "300": "#ff6666",
            "400": "#ff3333",
            "500": "#ff1a1a",
            "600": "#D70606",
            "700": "#b30505",
            "800": "#D70606", // Equal to 600 only in this customer
            "900": "#6b0303"
        },
        secondaryColor: {
            "50": "#f5f5f5",
            "100": "#e9e9e9",
            "200": "#d9d9d9",
            "300": "#c4c4c4",
            "400": "#9d9d9d",
            "500": "#7b7b7b",
            "600": "#555555",
            "700": "#434343",
            "800": "#262626",
            "900": "#000000"
        },
    },
    // Formula-e
    4: {
        primaryColor: {
            "50": "#f5f5f5",
            "100": "#e9e9e9",
            "200": "#d9d9d9",
            "300": "#c4c4c4",
            "400": "#9d9d9d",
            "500": "#7b7b7b",
            "600": "#555555",
            "700": "#434343",
            "800": "#262626",
            "900": "#000000"
        },
        secondaryColor: {
            "50": "#f0e6ff",
            "100": "#d5c2ff",
            "200": "#b798ff",
            "300": "#966bff",
            "400": "#7745ff",
            "500": "#5013ff",
            "600": "#3b0eff",
            "700": "#0000ff",
            "800": "#0000fb",
            "900": "#0000f9"
        },
    },
}
